/* 订单追踪页面迁移：
分为四部分 迁移
1.头部的搜索部分
2.订单的列表展示部分
3.faq的静态展示部分
4.猜你喜欢部分
5.弹窗

*/
'use client';

import RecommendList from '@/components/GuessYouLike';
import { useStore } from '@/providers/app-store-provider';
import { Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import FaqSection from './components/FaqSection';
import SearchHeader from './components/SearchHeader';
import TrackOrderDialog from './components/TrackOrderDialog';
import TrackOrderList from './components/TrackOrderList';
import { useTrackLikeList } from './hooks/useTrackLikeList';
import { useTrackOrderList } from './hooks/useTrackOrderList';
import { useTrackOrderSearch } from './hooks/useTrackOrderSearch';

export default function TrackOrderPageClient() {
  const t = useTranslations('track-order.page');
  // 搜索逻辑
  const { searchState, searchOrder, resetSearch } = useTrackOrderSearch();

  // 订单列表
  const { orderListState, fetchOrderList } = useTrackOrderList();

  // 猜你喜欢
  const {
    likeListState,
    fetchLikeList,
    handleRecommendMktExp,
    handleRecommendMktValidExp,
    handleRecommendMktClick,
  } = useTrackLikeList();

  const setShowLoginRegisterDialog = useStore((state) => state.setShowLoginRegisterDialog);

  useEffect(() => {
    fetchOrderList();
    fetchLikeList();
  }, []);

  // 处理搜索
  const handleSearch = (searchValue: string) => {
    searchOrder(searchValue);
  };

  // 处理订单点击
  const handleOrderClick = (order: any) => {
    searchOrder(order.order_no);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 1. 头部搜索部分 */}
      <SearchHeader onSearch={handleSearch} loading={searchState.loading} />

      <div className="w-full flex flex-col items-center justify-center max-w-[928px] mx-auto  mb-40  text-left">
        {!orderListState.isLogin && (
          <div className="w-full text-center md:text-left text-12">
            <span className="md:mr-8">{t('dontKnowOrderNo')}</span>
            <span className="md:hidden">
              <br />
              <br />
            </span>
            <span>
              <span
                onClick={() => {
                  setShowLoginRegisterDialog({
                    show: true,
                    eventType: 'track_order',
                    situation: '订单查询登录',
                  });
                }}
                className="underline cursor-pointer"
              >
                {t('signIn')}
              </span>
              {t('toAccessIt')}
            </span>
          </div>
        )}
        {/* 2. 订单的列表展示部分 */}
        {orderListState.hasData && (
          <TrackOrderList
            orderList={orderListState.orderList}
            loading={orderListState.loading}
            onOrderClick={handleOrderClick}
          />
        )}
        {!orderListState.hasData && orderListState.isLogin && (
          <div className="text-[14px] text-[#666] text-center py-[32px]">
            {t('noUndeliveredOrders')}
          </div>
        )}
      </div>

      {/* 3. FAQ的静态展示部分 */}
      <FaqSection />

      {/* 4. 猜你喜欢部分 */}
      <Box className="text-center xl:pt-[40px] xl:pb-[20px] xl:px-[9.375vw] bg-[#ffffff]">
        <RecommendList
          list={likeListState.list}
          listClassName="2xl:grid-cols-4"
          renderTitle={(title) => (
            <p className="mb-[16px] lg:mb-[35px] text-[14px] lg:text-[36px] font-bs">{title}</p>
          )}
          onMktExp={handleRecommendMktExp}
          onValidMktExp={handleRecommendMktValidExp}
          onMktClick={handleRecommendMktClick}
        />
      </Box>

      {/* 5. 弹窗 - 显示详细的追踪信息 */}
      <TrackOrderDialog
        show={searchState.showTrackOrder}
        orderDetail={searchState.searchResults}
        onClose={() => {
          resetSearch();
        }}
      />
    </div>
  );
}
